import { render, staticRenderFns } from "./history-modal.vue?vue&type=template&id=43aa8531&scoped=true"
import script from "./history-modal.vue?vue&type=script&lang=js"
export * from "./history-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aa8531",
  null
  
)

export default component.exports